import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const FileSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default FileSVG;
